import { useNProgress } from '../hooks/useNprogress';

export const Loading = () => {
  useNProgress();
};
